(() => {
  const setReadmore = (button, target, open) => {
    target.dataset.expanded = open ? 'true' : 'false';
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    button.textContent = open ? 'Show Less' : 'Show More';

    if (open) {
      target.style.maxHeight = `${target.scrollHeight}px`;
      return;
    }

    target.style.maxHeight = `${target.scrollHeight}px`;
    target.getBoundingClientRect();
    target.style.maxHeight = '0px';
  };

  const initReadmores = (scope) => {
    scope.querySelectorAll('.fa-linkbtn[aria-controls]').forEach((button) => {
      if (button.dataset.faReadmoreReady === 'true') return;
      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (!target) return;

      button.dataset.faReadmoreReady = 'true';
      setReadmore(button, target, false);
      button.addEventListener('click', () => {
        setReadmore(button, target, button.getAttribute('aria-expanded') !== 'true');
      });
    });
  };

  const initTabs = (scope) => {
    scope.querySelectorAll('[role="tablist"]').forEach((list) => {
      if (list.dataset.faTabsReady === 'true') return;
      const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      const panels = tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
      const activate = (activeIndex) => {
        tabs.forEach((tab, index) => {
          const active = index === activeIndex;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, index) => {
          if (panel) panel.dataset.active = index === activeIndex ? 'true' : 'false';
        });
      };

      list.dataset.faTabsReady = 'true';
      tabs.forEach((tab, index) => tab.addEventListener('click', () => activate(index)));
      activate(0);
    });
  };

  const init = (scope = document) => {
    initTabs(scope);
    initReadmores(scope);
  };

  document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
